import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EWorkshopModel } from '../../models/e-workshop.model';
import { PersianTitlesService } from '../../../../core/services/persian-titles.service';
import { RegistrationApprovalService } from '../../../../core/services/registration-approval.service';
import { Router } from '@angular/router';
import { RegistrationApprovalModel } from '../../../workshop/models/registration-approval.model';
import { CommonModule } from '@angular/common';
import {
  SharedWorkshopCardComponent,
  SharedWorkshopCardAction,
  SharedWorkshopCardRow,
} from 'src/app/shared/components/shared-workshop-card/shared-workshop-card.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PersianTimePipe } from '../../../../shared/pipes/persian-time.pipe';
import { RegistrationApprovalPromptComponent } from '../../../../shared/components/registration-approval-prompt/registration-approval-prompt.component';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-e-workshop-card',
  templateUrl: './e-workshop-card.component.html',
  styleUrls: ['./e-workshop-card.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DialogModule,
    SharedWorkshopCardComponent,
    RegistrationApprovalPromptComponent,
  ],
  providers: [PersianTimePipe],
})
export class EWorkshopCardComponent implements OnInit, OnDestroy {
  @Input('workshop') workshop!: EWorkshopModel;
  subscription: Subscription;

  // Labels
  teacherLabel: string = '';
  viewLabel: string = '';
  registrationApprovalProps!: RegistrationApprovalModel;
  showApprovalPromptPopup: boolean = false;
  cardActions: SharedWorkshopCardAction[] = [];
  cardRows: SharedWorkshopCardRow[] = [];

  constructor(
    private persianTitlesService: PersianTitlesService,
    private registrationApprovalService: RegistrationApprovalService,
    private router: Router,
    private translateService: TranslateService,
    private persianTimePipe: PersianTimePipe,
  ) {}

  ngOnInit() {
    this.initLabel();
    this.initRows();
    this.initActions();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private initLabel() {
    this.teacherLabel = this.persianTitlesService.Items.Teacher;
    this.viewLabel = this.persianTitlesService.Items.View;
  }

  private initRows() {
    this.cardRows = [
      {
        icon: 'lucideClock',
        title: '',
        value: this.persianTimePipe.transform(this.workshop.duration ?? 0),
      },
      {
        icon: 'lucideLayers',
        title: '',
        value: (this.workshop.totalVideos ?? 0) + ' جلسه',
      },
      {
        icon: 'lucideUser',
        title: this.teacherLabel,
        value: this.workshop.teacherFullName,
      },
    ];
  }

  private initActions() {
    this.cardActions = [
      {
        type: 'button',
        label: this.viewLabel,
        severity: 'primary',
        onClick: () => this.onViewButtonClick(this.workshop),
      },
    ];
  }

  onViewButtonClick(workshop: EWorkshopModel) {
    this.subscription = this.registrationApprovalService
      .getRegistrationApprovalStatus()
      .subscribe((resp) => {
        this.registrationApprovalProps = resp;
        if (!this.registrationApprovalProps.hasApprovalForRegistering) {
          this.showApprovalPromptPopup = true;
        } else {
          this.router.navigateByUrl(`e-workshops/${workshop.id}`);
        }
      });
  }
}
